import { render } from "./customer-segments-v2.vue?vue&type=template&id=61606009&scoped=true"
import script from "./customer-segments-v2.vue?vue&type=script&lang=js"
export * from "./customer-segments-v2.vue?vue&type=script&lang=js"

import "./customer-segments-v2.vue?vue&type=style&index=0&id=61606009&lang=css"
import "./customer-segments-v2.vue?vue&type=style&index=1&id=61606009&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61606009"]])

export default __exports__